<mat-dialog-content>
  @if (form ) {
    <form [formGroup]="form">
      @if (visualizedInTabGroup) {
        <mat-tab-group>
          @for (tab of htmlData; track tab) {
            <mat-tab [label]="tab.tabGroupName|translate">
              <div [ngClass]="[class]" class="flex-start-center flex-direction-row">
                @for (field of tab.forms; track field) {
                  <div class="size-form">
                    <app-get-form-field-from-configuration-file
                      [type]="field.type"
                      [titleTraduction]="field.traduction"
                      [possibleValues]="field.possibleValues"
                      [formControlName]="field.formControlName"
                      [iconPushButton]="field.icon"
                      [enableDisabelEmitEvent]="false"
                      [isTouched]="form.get(field.formControlName)?.dirty"
                      [visualizedClearButton]="false"
                      >
                      <button
                        mat-icon-button
                        suffix
                        (click)="$event.stopPropagation();unsetValue(field.formControlName,field.type)">
                        <mat-icon>clear</mat-icon>
                      </button>
                    </app-get-form-field-from-configuration-file>
                    @if (field.formGroupChild) {
                      <mat-card>
                        <ng-container [formGroupName]="field.formGroupChild.formGroupName">
                          @for (subForm of field.formGroupChild.fields; track subForm) {
                            <app-get-form-field-from-configuration-file
                              [type]="subForm.type"
                              [titleTraduction]="subForm.traduction"
                              [possibleValues]="subForm.possibleValues"
                              [formControlName]="subForm.formControlName"
                              [iconPushButton]="field.icon"
                              [enableDisabelEmitEvent]="false"
                              [isTouched]="form.get(field.formControlName)?.dirty"
                              [visualizedClearButton]="false"
                              >
                              <button
                                mat-icon-button
                                suffix
                                (click)="$event.stopPropagation();unsetValue(subForm.formControlName,subForm.type)">
                                <mat-icon>clear</mat-icon>
                              </button>
                            </app-get-form-field-from-configuration-file>
                          }
                        </ng-container>
                      </mat-card>
                    }
                  </div>
                }
              </div>
            </mat-tab>
          }
        </mat-tab-group>
      } @else {
        <div [ngClass]="[class]" class="flex-start-center flex-direction-row">
          @for (tab of htmlData; track tab) {
            @for (field of tab.forms; track field) {
              <div class="size-form">
                <app-get-form-field-from-configuration-file
                  [type]="field.type"
                  [titleTraduction]="field.traduction"
                  [possibleValues]="field.possibleValues"
                  [formControlName]="field.formControlName"
                  [iconPushButton]="field.icon"
                  [enableDisabelEmitEvent]="false"
                  [isTouched]="form.get(field.formControlName)?.dirty"
                  [visualizedClearButton]="false"
                  >
                  <button
                    mat-icon-button
                    suffix
                    (click)="$event.stopPropagation();unsetValue(field.formControlName,field.type)">
                    <mat-icon>clear</mat-icon>
                  </button>
                </app-get-form-field-from-configuration-file>
              </div>
              @if (field.formGroupChild) {
                <mat-card>
                  <ng-container [formGroupName]="field.formGroupChild.formGroupName">
                    @for (subForm of field.formGroupChild.fields; track subForm) {
                      <app-get-form-field-from-configuration-file
                        [type]="subForm.type"
                        [titleTraduction]="subForm.traduction"
                        [possibleValues]="subForm.possibleValues"
                        [formControlName]="subForm.formControlName"
                        [iconPushButton]="field.icon"
                        [enableDisabelEmitEvent]="false"
                        [isTouched]="form.get(field.formControlName)?.dirty"
                        [visualizedClearButton]="false"
                        >
                        <button
                          mat-icon-button
                          suffix
                          (click)="$event.stopPropagation();unsetValue(subForm.formControlName,subForm.type)">
                          <mat-icon>clear</mat-icon>
                        </button>
                      </app-get-form-field-from-configuration-file>
                    }
                  </ng-container>
                </mat-card>
              }
            }
          }
        </div>
      }
    </form>
  }
</mat-dialog-content>
<mat-dialog-actions style="justify-content: center">
  <button class="fab" color="accent" mat-flat-button
    matTooltip="{{'button.save' | translate}}"
    [mat-dialog-close]="undefined">
    <mat-icon>clear</mat-icon>
  </button>
  <button class="fab" color="primary" mat-flat-button [disabled]="disabledSaveButton||this.form.invalid"
    matTooltip="{{'button.save' | translate}}"
    (click)="clickSaveButton()">
    <mat-icon>save</mat-icon>
  </button>
</mat-dialog-actions>
